import React from "react";
import classnames from "classnames";

interface Props {
    incrementPage: () => void;
    decrementPage: () => void;
    page: number;
    canGoNext: boolean;
    className?: string;
}

const SagePaginationButton: React.FC<Props> = ({
    incrementPage,
    decrementPage,
    page,
    canGoNext,
    className,
}) => {
    return (
        <div
            className={classnames("btn-group btn-group-sm", className)}
            role="group"
        >
            <button
                onClick={decrementPage}
                type="button"
                className="btn btn-secondary"
                disabled={page <= 0}
            >
                Previous
            </button>
            <button
                onClick={incrementPage}
                disabled={!canGoNext}
                type="button"
                className="btn btn-secondary"
            >
                Next
            </button>
        </div>
    );
};

export default SagePaginationButton;
